"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisionApiOperations = void 0;
var RevisionApiOperations;
(function (RevisionApiOperations) {
    RevisionApiOperations[RevisionApiOperations["List"] = 0] = "List";
    RevisionApiOperations[RevisionApiOperations["Delete"] = 1] = "Delete";
    RevisionApiOperations[RevisionApiOperations["Get"] = 2] = "Get";
})(RevisionApiOperations || (exports.RevisionApiOperations = RevisionApiOperations = {}));
